export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            投稿咨询
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            欢迎漫画作者与读者与我们联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-mail-line text-xl text-accent-700"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">tougao@yinghuamanhua.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-chat-3-line text-xl text-secondary-700"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">合作咨询</h3>
              <p className="text-xs text-foreground-500">hezuo@yinghuamanhua.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-question-answer-line text-xl text-primary-700"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">读者反馈</h3>
              <p className="text-xs text-foreground-500">fankui@yinghuamanhua.com</p>
            </div>
          </div>

          <form data-readdy-form="contact" className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="你的昵称"
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md text-foreground-700 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="联系邮箱"
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md text-foreground-700 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
              />
            </div>
            <textarea
              name="message"
              placeholder="请描述你的投稿方向或咨询内容…"
              rows={4}
              maxLength={500}
              className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md text-foreground-700 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"
            ></textarea>
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="contact-hp"
            />
            <button
              type="button"
              className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              发送消息
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}